const overview_table = {
	cpu: "CPU-Kerne",
	mem: "RAM-Speicher",
	name: "Name",
	os_name: "Das Betriebssystem",
	status: "Status",
};

export default overview_table;
